module.exports = __webpack_public_path__ + "static/media/SuppliFireworks.4b0b3f47.svg";